import { useNavigate } from "react-router-dom";
import { MerchantsPage as MerchantsPageView } from "@/components/MerchantsPage";

export function MerchantsPage() {
  const navigate = useNavigate();
  return <MerchantsPageView onSelect={(id) => navigate(`/expenses/merchants/${id}`)} />;
}
